import { useState } from "react"
import { IntroPage } from "./IntroPage"
import { makeStateObservableToReact } from "../../utilities"
import { TypeOfActivityPage } from "./TypeOfActivityPage"
import { TurnOverPage } from "./TurnOverPage"
import { ExpensesPage } from "./ExpensesPage"
import { AllowancePage } from "./AllowancePage"
import { DependentsPage } from "./DependentsPage"
import { ResultPage } from "./ResultPage"
import { TypeOfActivity } from "../../logic/vennootschapofniet/taxesinput"

export class VonState {
  introVisible: boolean = true
  typeOfActivity?: TypeOfActivity
  turnOver?: number
  expenses?: number
  allowance?: number
  dependents?: number
  dateOfBirth?: Date
}

function validateState(vonState: VonState): Required<VonState> {
  // This function could do with some rigoureus error checking like `if (field === undefined) throw new Error("Useful message")`.
  // But for now, we just assume there are no undefined values.
  return {
    introVisible: vonState.introVisible,
    typeOfActivity: vonState.typeOfActivity!,
    turnOver: vonState.turnOver!,
    expenses: vonState.expenses!,
    allowance: vonState.allowance!,
    dependents: vonState.dependents!,
    dateOfBirth: vonState.dateOfBirth!
  }
}

export default function VennootschapOfNietPage() {
  let [vonState, setVonStateImpl] = useState(new VonState())

  function setVonState(newState: VonState) {
    setVonStateImpl(makeStateObservableToReact(newState))
  }

  if (vonState.introVisible) {
    vonState.introVisible = false

    /*
    Go te result from inital render
    setVonState({
      introVisible: false,
      typeOfActivity: TypeOfActivity.Main,
      turnOver: 80000,
      expenses: 20000,
      allowance: 16400,
      dependents: 0,
      dateOfBirth: new Date()
    })
    */

    return <IntroPage goToNextPage={() => setVonState(vonState)} />
  }

  if (vonState.typeOfActivity === undefined) {
    return <TypeOfActivityPage setState={(type) => {
      vonState.typeOfActivity = type
      setVonState(vonState)
    }} />
  }

  if (vonState.turnOver === undefined) {
    return <TurnOverPage setState={(turnOver) => {
      vonState.turnOver = turnOver
      setVonState(vonState)
    }} />
  }

  if (vonState.expenses === undefined) {
    return <ExpensesPage setState={(expenses) => {
      vonState.expenses = expenses
      setVonState(vonState)
    }} />
  }

  if (vonState.allowance === undefined) {
    return <AllowancePage setState={(allowance) => {
      vonState.allowance = allowance
      setVonState(vonState)
    }} />
  }

  if (vonState.dependents === undefined) {
    return <DependentsPage setState={(dependents, dateOfBirth) => {
      vonState.dependents = dependents
      vonState.dateOfBirth = dateOfBirth
      setVonState(vonState)
    }} />
  }

  const input = validateState(vonState)
  return <ResultPage input={input} goToIntroPage={() => setVonState(new VonState())} />
}
